<div
  class="crm-spinner text-center {{ bottom }}"
  [ngClass]="top">
  <svg
    class="crm-spinner__ring"
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 56 56"
    fill="none"
    aria-hidden="true">
    <circle cx="28" cy="28" r="22" fill="none" stroke="#e0f7f6" stroke-width="5" />
    <g class="crm-spinner__rot">
      <circle
        cx="28"
        cy="28"
        r="22"
        fill="none"
        stroke="#22d3c8"
        stroke-width="5"
        stroke-dasharray="42 180"
        stroke-linecap="round"
        transform="rotate(-90 28 28)" />
    </g>
  </svg>
  @if (text?.length) {
    <h3>{{ text }}</h3>
  }
</div>
